import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LANGUAGES , ACCOUNT_SECURITY_BAN_STATUS } from '../../constants';
import { trans } from '../../localization/language';
import * as commonActions from '../../actions/common';

class TopBar extends React.Component {
	handleLogout() {
		this.props.logout();
	}
	
	handleChangeLanguage(index) {
		this.props.changeLanguageAction(LANGUAGES[index]);
	}
	
	renderLanguageOption(index, isActive) {
		return (
			<a href="#" className={isActive ? "hd-lang__select-item hd-lang__select-item--cur" : "hd-lang__select-item"}
				key={index.toString()} onClick={() => this.handleChangeLanguage(index)}>
				{LANGUAGES[index].name}
			</a>
		);
	}

	renderActiveLanguage() {
		return (
			<a href="javascript:;" className="hd-lang__cur">
				<div className="hd-lang__cur-txt">
					{this.props.language.name}
				</div>
			</a>
		);
	}

	renderLanguageList() {
		var languageList = [];
		for (var i = 0; i < LANGUAGES.length; ++i) {
			var isActive = (LANGUAGES[i] === this.props.language);
			var languageOption = this.renderLanguageOption(i, isActive);
			languageList.push(languageOption);
		}
		return (
			<div className="hd-lang__select">
				{languageList}
			</div>
		);
	}

	renderLanguageComponent() {
		return (
			<div className="hd-lang">
				{this.renderActiveLanguage()}
				{this.renderLanguageList()}
			</div>
		);
	}
	handleASide(direction) {
		document.body.classList.add( 'body--'+direction+'expanded' );
	}

	renderMobileLeftPanelTrigger() {
		if (!(this.props.userInfo.status & ACCOUNT_SECURITY_BAN_STATUS)) {
			return (
				<div className="hd-trigger" id="J-msidebar-left-trigger" onClick={()=>this.handleASide('left')}></div>
			);
		}
	}

	renderMobileRightPanelTrigger() {
		if (!(this.props.userInfo.status & ACCOUNT_SECURITY_BAN_STATUS)) {
			return (
				<img src={this.props.userInfo.avatar} alt="" className="hd-thumb" id="J-msidebar-right-trigger" onClick={()=>this.handleASide('right')}></img>
			);
		}
	}
	
	render() {
		return (
			<div className="hd">
				<div className="hd-main">
					{this.renderMobileLeftPanelTrigger()}
					<a className="hd-logo"></a>
					<div className="hd-panel">
						{this.renderMobileRightPanelTrigger()}
						<div className="hd-name">
							{this.props.userInfo.username}
						</div>
						<a href="#" className="hd-operation" onClick={this.handleLogout.bind(this)}>{trans('logout')}</a>
						{this.renderLanguageComponent()}
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		language: state.data.language
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, commonActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TopBar);


// WEBPACK FOOTER //
// ./app/components/header/TopBar.js